/**
 * The two readings of a ledger record that more than one screen needs.
 *
 * Shared rather than copied: the recovery drawer shows the same amounts as the
 * ledger it recovers into, and a conversion has to be recognised identically in
 * both or one screen offers an edit the other forbids.
 */

export const formatMoney = (currency, amount) => `${currency} ${Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Either leg of a currency conversion: the fx_settlement that re-opens the
// balance in the target currency, or the clearing payment that zeroes the
// source one. `is_fx_conversion_leg` is set by the API for both; the
// entry_type check is a fallback for a cached response from an older build.
export const isConversionLeg = (record) => (
  record.is_fx_conversion_leg === true || record.entry_type === 'fx_settlement'
);

/** "Expense" / "Settlement" / "Conversion", the way the ledger labels it. */
export const describeEntryType = (record) => (
  isConversionLeg(record) ? 'Conversion' : record.entry_type === 'payment' ? 'Settlement' : 'Expense'
);
